import ControllerBase from '../../../../global/js/ControllerBase';

export default class ControllerTeaserListItem extends ControllerBase {
	/** A list of dom element references available to this component */
	private readonly componentRefs = {
		clickableDiv: 'clickableDiv',
	};

	private readonly url: string;
	private readonly clickable: boolean;

	constructor(element: HTMLElement) {
		super(element);

		this.url = this.$element.dataset['url'] || '';
		this.clickable = this.$element.dataset['clickable'] === 'true';
		this.observeClicks();
	}

	/**
	 * Observe container clicks
	 */
	private observeClicks(): void {
		if (this.clickable && this.url) {
			const div = this.$references[this.componentRefs.clickableDiv] as HTMLDivElement;
			div.addEventListener('click', (e) => {
				e.preventDefault();
				window.location.href = this.url;
			});
		}
	}
}
